import React from "react";
import Select from "react-select";

const SessionCategoryForm = ({ formData, handleChange }) => {
    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '38px',
            fontSize: '0.875rem',
            borderRadius: '0.375rem',
            borderColor: '#d9dee3',
            '&:hover': { borderColor: '#d9dee3' }
        }),
        menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 9999 }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#666ee8' : state.isFocused ? '#f5f5f9' : 'white',
            color: state.isSelected ? 'white' : '#566a7f',
            cursor: 'pointer',
        })
    };

    const currentStatus = statusOptions.find(opt => opt.value === formData.status) || statusOptions[0];

    return (
        <div className="content p-4">
            <div className="row g-3">
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-2 py-1 mb-3">
                        Session Category Information
                    </small>
                </div>

                <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-3" style={{ marginTop: '22px' }}>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name || ""}
                            onChange={handleChange}
                            placeholder="Enter Name"
                            required
                        />
                        <label>Name <span className="text-danger">*</span></label>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="mb-3">
                        <label className="form-label small fw-bold">Status</label>
                        <Select
                            options={statusOptions}
                            styles={selectStyles}
                            value={currentStatus}
                            onChange={(opt) => handleChange({ target: { name: "status", value: opt ? opt.value : "active" } })}
                            placeholder="Select Status"
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SessionCategoryForm;
